import { isValidCnpjNormalized } from '@solfacil/frontend-utils/cnpj';
import { isValidCpfNormalized } from '@solfacil/frontend-utils/cpf';
import { z } from 'zod';

const onlyDigits = (value: string) => value.replace(/\D/g, '');

export const createTitularityTransferSchema = (currentDocument: string) => z.object({
  newDocument: z
    .string({ required_error: 'Informe o novo CPF/CNPJ' })
    .transform(onlyDigits)
    .refine(
      (digits) => digits.length === 11 || digits.length === 14,
      'Informe um CPF (11 dígitos) ou CNPJ (14 dígitos)',
    )
    .refine(
      (digits) => (digits.length === 11 ? isValidCpfNormalized(digits) : isValidCnpjNormalized(digits)),
      'Documento inválido',
    )
    .refine((digits) => digits !== onlyDigits(currentDocument), 'O novo documento deve ser diferente do titular atual'),
});

export type TitularityTransferForm = z.input<ReturnType<typeof createTitularityTransferSchema>>;
